import { Box, Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import { Property, PropertyAmenity } from "../../types";

export default function AmenitiesSection({
  property,
  buildingAmenities,
}: {
  property: Property;
  buildingAmenities?: PropertyAmenity[];
}) {
  const theme = useTheme();

  const amenityBadge = (id: number, name: string) => (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
      key={id}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "16px",
          height: "16px",
          justifyContent: "center",
          background: "#B2D1CA",
          borderRadius: "50%",
        }}
      >
        <Check
          size="10px"
          style={{
            color: theme.nawy.colors.semantic.layer.extension.positive,
          }}
        />
      </div>
      <Typography
        sx={(theme) =>
          theme.nawy.typography.english.variants.body.md.regular
        }
      >
        {name}
      </Typography>
    </Box>
  );

  const effectiveBuildingAmenities =
    buildingAmenities ?? property.parentBuildingAmenities;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {effectiveBuildingAmenities && effectiveBuildingAmenities.length > 0 && (
        <>
          <Typography
            sx={(theme) =>
              theme.nawy.typography.english.variants.body.xs.semibold
            }
          >
            Building Amenities
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "40px",
              justifyContent: "start",
            }}
          >
            {effectiveBuildingAmenities.map((item) =>
              amenityBadge(item.amenity.id, item.amenity.name),
            )}
          </Box>
        </>
      )}
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.body.xs.semibold}
      >
        Amenties
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          justifyContent: "start",
        }}
      >
        {property.propertyAmenity.length > 0 ? (
          property.propertyAmenity.map((item) =>
            amenityBadge(item.amenity.id, item.amenity.name),
          )
        ) : (
          <Typography>No amenities available.</Typography>
        )}
      </Box>
    </Box>
  );
}
